import React, { useState } from "react";
import { Box, Button, Chip, TextField, Typography } from "@mui/material";
import BoxMedia from "../../items/fragments/BoxMedia.js";
import { addQuestionToQuestionBox } from "../../../../../api/index.js";

const MediaQuestionBox = ({ item, match, onTagClick }) => {
  const { _id, title } = item;
  const [pseudo, setPseudo] = useState("");
  const [question, setQuestion] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async () => {
    setError(undefined)
    if (pseudo && question) {
      try {
        const res = await addQuestionToQuestionBox(_id, { pseudo, question });
        if (res.status === 200) {
          setIsSubmitted(true);
        }
      } catch (err) {
        console.error("Erreur lors de l'envoi de la question", err);
        const message = err.response?.data || "Une erreur s'est produite lors de l'envoi.";
        setError(message);
      }
    }
  };

  return (
    <BoxMedia media={item} match={match} onTagClick={onTagClick}>
      <Typography variant="mediaH2" component="div" sx={{
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
      }}>{title}</Typography>

      <Box sx={{ mt: 2, position: "relative", minHeight: "180px" }}>
        {isSubmitted && (
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 1,
              textAlign: "center"
            }}
          >
            <Typography variant="body1">
              Merci <strong>{pseudo}</strong> pour votre question !
            </Typography>
          </Box>
        )}

        {/* Formulaire masqué visuellement mais garde l'espace */}
        <Box sx={{ visibility: isSubmitted ? 'hidden' : 'visible' }}>
          <TextField
            label="Pseudo"
            variant="outlined"
            value={pseudo}
            onChange={(e) => setPseudo(e.target.value)}
            fullWidth
          />
          <TextField
            label="Votre question"
            variant="outlined"
            multiline
            rows={3}
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            fullWidth
            sx={{ mt: 2 }}
          />
          {error && (
            <Typography color="error" variant="body2" sx={{ mt: 1 }}>
              {error}
            </Typography>
          )}
          <Button
            variant="contained"
            disabled={!pseudo || !question}
            onClick={handleSubmit}
            sx={{ mt: 2 }}
          >
            Envoyer ma question
          </Button>
        </Box>
      </Box>
    </BoxMedia>
  );
};

export default MediaQuestionBox;
